<template>
  <div id="main">
    <div>
      <Title />
    </div>
    <div class="dashboard-grid">
      <div>
        <Chancellor />
        <ChartFooter />
      </div>
      <div>
        <PartOfGov />
        <ChartFooter />
      </div>
      <div>
        <Coalition />
        <ChartFooter />
      </div>
      <div>
        <Forecast />
        <ChartFooter />
      </div>
    </div>
  </div>
</template>

<script>
import Forecast from "./Forecast.vue";
import Title from './Title.vue'
//  import Events from './Events.vue'
import PartOfGov from "./PartOfGov.vue";
import Coalition from "./Coalition.vue";
import Chancellor from "./Chancellor.vue";
import ChartFooter from "./ChartFooter.vue";

export default {
  name: "Dashboard",
  components: {
    Chancellor,
    PartOfGov,
    Coalition,
    Forecast,
    ChartFooter,
    Title,
  },
};
</script>


<style>
.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2em;
  margin: 2em;
}

.dashboard-grid > div {
  position: relative;
}

.dashboard-grid .mt-5 {
      background: var(--blue-light);
      height: calc(100% - 4em);
}

.content.dashboard {
    padding: 0;
}

@media screen and (min-width: 1200px) {
  .dashboard-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>